import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowUpRightFromSquare,
  faBuilding,
  faChartSimple,
  faCookie,
  faGear,
  faHandshake,
  faHouse,
  faIdCard,
  faMagnifyingGlassLocation,
  faPaintbrush,
  faBorderAll,
  faDatabase,
  faGraduationCap,
  faRightFromBracket,
  faSquareCheck,
  faUserGear,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBuilding as faBuildingSolid,
  faChartSimple as faChartSimpleSolid,
  faHandshake as faHandshakeSolid,
  faHouse as faHouseSolid,
  faIdCard as faIdCardSolid,
  faSquareCheck as faSquareCheckSolid,
  faUsers as faUsersSolid,
} from '@fortawesome/pro-solid-svg-icons';

const IDLE_ICONS: Record<string, IconDefinition> = {
  tasks: faSquareCheck,
  dashboard: faHouse,
  properties: faBuilding,
  contacts: faUsers,
  deals: faHandshake,
  back_office: faIdCard,
  reports: faChartSimple,
};

const ACTIVE_ICONS: Record<string, IconDefinition> = {
  tasks: faSquareCheckSolid,
  dashboard: faHouseSolid,
  properties: faBuildingSolid,
  contacts: faUsersSolid,
  deals: faHandshakeSolid,
  back_office: faIdCardSolid,
  reports: faChartSimpleSolid,
};

export function navIcon(key: string, isActive: boolean): IconDefinition | undefined {
  return isActive ? ACTIVE_ICONS[key] : IDLE_ICONS[key];
}

export const PROFILE_ICONS: Record<string, IconDefinition> = {
  profile_settings: faUserGear,
  company_settings: faGear,
  branding: faPaintbrush,
  upgrade: faArrowUpRightFromSquare,
  prospect: faMagnifyingGlassLocation,
  cookie_settings: faCookie,
  logout: faRightFromBracket,
  database: faDatabase,
  grids: faBorderAll,
  switch_accounts: faUserGear,
  academy: faGraduationCap,
  rethink: faArrowUpRightFromSquare,
};
